import {
  FilterInputGrouped,
  ParagraphFarmCategoryFragment,
} from '../generated/types';

export default function getFilterGroups(
  searchMoreFilter: ParagraphFarmCategoryFragment[],
  filterIds: number[]
) {
  const filterGroups: FilterInputGrouped[] = [];

  // Build groups
  searchMoreFilter.forEach((searchMoreFilterParagraph) => {
    // Check if we have any of its categoryTerms active
    const activeItems: number[] = [];

    // Can only contain either parent or subcategories
    if (filterIds.includes(searchMoreFilterParagraph.category.id)) {
      filterGroups.push({
        conditions: [
          {
            field: 'category',
            value: `${searchMoreFilterParagraph.category.id}`,
            operator: '=',
          },
        ],
      });
    } else {
      searchMoreFilterParagraph.subCategories?.forEach((subCategory) => {
        if (filterIds.includes(subCategory.id)) {
          activeItems.push(subCategory.id);
        }
      });

      if (activeItems.length) {
        if (searchMoreFilterParagraph.category.conjunction === 'or') {
          // Any of the following terms
          filterGroups.push({
            conditions: [
              {
                field: 'sub_categories',
                value: `${activeItems.join(',')}`,
                operator: 'IN',
              },
            ],
          });
        } else {
          // each of the following terms
          filterGroups.push({
            conditions: activeItems.map((id) => ({
              field: 'sub_categories',
              value: `${id}`,
              operator: '=',
            })),
          });
        }
      }
    }
  });

  return filterGroups;
}
